import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} TopPopProps
 */

/**
 * TopPop component.
 * @augments {Base<TopPopProps>}
 */
export default class TopPop extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'TopPop',
    refs: ['close', 'topHeader', 'popin'],
    options: {
      delay: {
        type: String,
        default: '5',
      },
      cookieName: {
        type: String,
        default: 'popin',
      },
    },
  };

  /**
   * Get Popin visibility
   * @returns {string|null}
   */
  get popinVisibility() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${this.$options.cookieName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  /**
   * Set Popin visibility
   * @param  {string} value
   * @returns {void}
   */
  set popinVisibility(value) {
    // eslint-disable-next-line unicorn/no-document-cookie -- CookieStore API not supported in all browsers
    document.cookie = `${this.$options.cookieName}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
  }

  /**
   * Mount component and launch Popin
   * @returns {void}
   */
  mounted() {
    if (!this.popinVisibility) {
      const delay = this.$options.delay * 1000;
      setTimeout(() => {
        this.showPopin();
      }, delay);
    }
  }

  /**
   * Click on close btn and hide Popin
   * @returns {void}
   */
  onCloseClick() {
    this.hidePopin();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  showPopin() {
    this.$el.style.zIndex = 1000;
    this.$refs.popin.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   * Hide Popin
   * @returns {void}
   */
  hidePopin() {
    this.$refs.popin.classList.add('opacity-0', 'pointer-events-none');
    this.popinVisibility = true;
    this.$el.style.zIndex = '';

    if (this.$refs.topHeader) {
      this.$refs.topHeader.classList.add('top-header');
      this.$refs.topHeader.classList.remove('hidden');
    }
  }
}
